module.exports = __webpack_public_path__ + "img/00052.2e1fa1b6.webp";